import { useNavigate } from 'react-router-dom'
import { Eye, LogOut } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'

/**
 * Faixa fixa exibida enquanto um admin/colaborador visualiza o painel de uma
 * EMPRESA (impersonação). Permite voltar ao login original.
 */
export function ImpersonationBanner() {
  const nav = useNavigate()
  const depth = useAuthStore(s => s.impersonationStack.length)
  const user = useAuthStore(s => s.user)
  const stop = useAuthStore(s => s.stopImpersonation)

  if (depth === 0) return null

  function exit() {
    // Desempilha um nível e navega conforme o usuário RESTAURADO (para quem
    // estamos voltando). Em impersonação aninhada, repete até a origem.
    const restored = stop()
    const t = restored?.user?.type
    if (t && ['DIRETOR', 'SUPERVISOR', 'AFILIADO', 'VENDEDOR'].includes(t)) {
      nav('/partner/dashboard')
    } else if (t === 'EMPRESA') {
      nav('/my-company/dashboard')
    } else {
      nav('/') // admin/colaborador
    }
  }

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 bg-amber-500 text-white px-4 py-2 text-sm">
      <span className="flex items-center gap-2 min-w-0">
        <Eye size={15} className="shrink-0" />
        <span className="break-words">
          Você está visualizando como <strong>{user?.name ?? 'Empresa'}</strong>
        </span>
      </span>
      <button type="button" onClick={exit}
        className="cursor-pointer shrink-0 inline-flex items-center gap-1.5 rounded-md bg-white/20 hover:bg-white/30 px-3 py-1 font-medium transition">
        <LogOut size={14} /> Sair da visualização
      </button>
    </div>
  )
}
